import { mediaPath } from "@/lib/media";

const FRAME_BG = "bg-[#EBE5D9]";

/**
 * Card: 1:1 frame, full image visible (object-contain)
 * Hero: fills panel edge-to-edge (object-contain / optional cover)
 */
export default function CountryImage({
    src,
    alt = "",
    variant = "card",
    className = "",
    imgClassName = "",
}) {
    if (!src) return null;

    if (variant === "hero") {
        return (
            <img
                src={mediaPath(src)}
                alt={alt}
                className={`absolute inset-0 w-full h-full object-contain object-top lg:object-center block ${imgClassName} ${className}`}
                loading="eager"
                decoding="async"
            />
        );
    }

    return (
        <div
            className={`flex items-center justify-center w-full h-full ${FRAME_BG} ${className}`}
        >
            <img
                src={mediaPath(src)}
                alt={alt}
                className={`max-w-full max-h-full w-auto h-auto object-contain object-center block ${imgClassName}`}
                loading="lazy"
                decoding="async"
            />
        </div>
    );
}
